// extracted by mini-css-extract-plugin
export default {"title":"DomainIntro-title_s6z55","icon":"DomainIntro-icon_u3qJv"};